export const PACKAGE_NAME = 'com.discontract.discontract';
export const IOS_ID = '1477306259';
export const IOS_APP_STORE = `https://apps.apple.com/lt/app/discontract/id${IOS_ID}`;
export const ANDROID_GOOGLE_PLAY = `https://play.google.com/store/apps/details?id=${PACKAGE_NAME}`;
export const ANDROID_DIRECT_GOOGLE_PLAY = `market://details?id=${PACKAGE_NAME}`;
export const DYNAMIC_LINK_DOMAIN = 'https://app.discontract.com/';
export const DYNAMIC_LINK_DOWNLOAD = DYNAMIC_LINK_DOMAIN + 'download';
export const DYNAMIC_LINK_REFERRAL_DOWNLOAD = DYNAMIC_LINK_DOMAIN + 'referral';
